import React from 'react';
import './Learn.css';
import mvp from "../assets/o_metodo_vivencia_poliglota.pdf";
import mti from "../assets/mti_mapa_de_transformacao_individual.pdf";

function Learn() {
  return (
    <div className="app-learn w-full grid justify-items-center max-md:pb-5">
      <div className="section">
        <div className="grid max-sm:grid-rows-2 h-[100vh] md:h-[50vh] md:grid-cols-2 place-content-evenly gap-2">
          <div id="metodo" className="grid sm:p-5 h-full md:h-[50vh] justify-center content-center items-center justify-items-center">
              <div className="font-bold text-center text-2xl p-1">
                  Aprenda, viva, experiencie culturas
              </div>
              <div className="text-lg text-center p-1 pb-10">
                  Simule sua vida no idioma-alvo e comece a viagem
              </div>
              <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                    hover:bg-gradient-to-br font-bold text-2xl font-bold rounded-4xl text-center cta">
                  <a href={mvp} target='_blank' rel='noopener noreferrer'>
                      Método Vivência Poliglota</a>
              </button>
          </div>

          <div className="app-learn-img-01 h-full md:h-[50vh] w-full"></div>
        </div>
    
        <div className="grid max-sm:grid-rows-2 h-[100vh] md:h-[50vh] md:grid-cols-2 place-content-evenly gap-2">
          <div className="app-learn-img-02 h-full md:h-[50vh] w-full max-sm:order-last"></div>
            
          <div id="mti" className="grid sm:p-5 h-full md:h-[50vh] justify-center content-center items-center justify-items-center">
              <div className="font-bold text-center text-2xl p-1">
                  Prontos para começar a viagem?
              </div>
              <div className="text-lg text-center p-1 pb-10">
                  Comece a desenhar seu mapa de vôo. Nós te acompanharemos no processo. 
              </div>
              <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                  hover:bg-gradient-to-br font-bold text-2xl font-bold rounded-4xl text-center w-2/5 cta">
                  <a href={mti} target='_blank' rel='noopener noreferrer'>
                      MTI</a>
              </button>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Learn;
